module.exports = __webpack_public_path__ + "img/mp-solution-bg-7.1f655d13.jpg";